import React from 'react';
type OfferEndedButtonProps = {
  size?: 'md' | 'lg';
};

/** Botón desactivado que reemplaza a los botones de compra cuando vence la oferta. */
export function OfferEndedButton({
  size = 'md'
}: OfferEndedButtonProps) {
  const sizing = size === 'lg' ? 'py-5 text-lg sm:py-6 sm:text-2xl' : 'py-4 text-[17px] sm:py-5 sm:text-xl';
  return <button type="button" disabled aria-disabled="true" className={`flex w-full cursor-not-allowed items-center justify-center rounded-full border border-[#E3D3C6] bg-[#EFE4DA] px-6 text-center font-display font-extrabold uppercase leading-snug tracking-tight text-[#6B5A52] ${sizing}`} data-id="element-263" data-mp="3hougq3gml5z2">
      Oferta finalizada
    </button>;
}